import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AlfrescoService } from '../../_services/alfresco.service';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';


@Component( {
  selector: 'app-alfresco',
  templateUrl: 'alfresco.component.html'
} )

export class AlfrescoComponent implements OnInit, OnDestroy {

  formulario: FormGroup;
  submitted = false;
  carInformacionInicial = false;

  alfresco: any = {
    urlDestino: '',
    urlOrigen: ''
  }

  archivo: any = {
    total: '0',
    transferidos: '0',
    porcentaje: 0
  }
  error = false;
  porcentaje: any;
  msgs: any [] = [];

  constructor( private alfrescoService: AlfrescoService,
               private conServicio: ConfirmationService,
               private nav: NavService) {
  }


  ngOnInit(): void {
    this.alfrescoService.getUrl().subscribe( ( res: any ) => {
      this.alfresco = res;
      this.carInformacionInicial = true;
    } );
  }

  ngOnDestroy() {
    if ( this.porcentaje ) {
      this.limpiar();
    }
  }

  onSubmit() {
    this.submitted = true;
    const data = new FormData();
    this.alfrescoService.iniciar( data ).subscribe( ( res: any ) => {
      this.archivo.total = res;
      this.getProcentaje();
    }, error => {
      this.error = true;
      setTimeout( () => {
        this.limpiar();
      }, 6000 );
    } );
  }

  cancelar() {
    const data = new FormData();
    this.alfrescoService.detener( data ).subscribe( ( res: any ) => {
      this.submitted = false;
      this.error = false;
    } );
  }

  getProcentaje() {
    this.porcentaje = setInterval( () => {
      this.alfrescoService.getProgreso().subscribe( ( data: any ) => {
        this.archivo.transferidos = data.trsnferidos;
        this.archivo.porcentaje = data.porcentaje;
      }, error => {
        this.error = true;
        this.limpiar();
      } );
    }, 1000 );
  }

  limpiar() {
    clearInterval( this.porcentaje );
    this.submitted = false;
    this.error = false;
  }

  confirmar() {
    this.conServicio.confirm( {
      message: this.nav.buscarMensaje( 'ALFRESCO.MsG_CONFIRMACION' ),
      header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
        this.onSubmit();
      },
      reject: () => {
      }
    } );
  }

}
